module.exports = __webpack_public_path__ + "static/media/download_with_bg.e5e1bb05.svg";